// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1603":"npm.core-js","3773":"npm.dompurify","7383":"npm.html2canvas","8727":"npm.canvg"}[chunkId] || chunkId) + "." + {"1603":"0725e4d815ee1d318805","3773":"60eef57d67259df14b8b","4964":"ea97570969304fc19c01","7383":"00c89f2f669eb2a8a9bc","8727":"f46540969595f8fa26a9"}[chunkId] + ".js";
};